import React from 'react';
import { MessageCircle } from 'lucide-react';
import { clinicInfo } from '../data/mockData';

const WhatsAppButton = () => {
  const handleWhatsAppClick = () => {
            // ✅ TRACK EVENT (ADD THIS)
          if (window.gtag) {
            window.gtag('event', 'whatsapp_click', {
              event_category: 'conversion',
              event_label: 'Floating WhatsApp Button'
            });
          }
        const message = encodeURIComponent('Hello! I would like to book an appointment at The Eternal Care.');
          // Existing logic
          window.open(
            `https://wa.me/${clinicInfo.phone.replace(/[^0-9]/g, '')}?text=${message}`,
            '_blank'
          );
        };

  return (
    <>
      <button
        onClick={handleWhatsAppClick}
        className="whatsapp-float"
        aria-label="Chat on WhatsApp"
      >
        <MessageCircle size={28} />
      </button>

      <style jsx>{`
        .whatsapp-float {
          position: fixed;
          bottom: 24px;
          right: 24px;
          width: 60px;
          height: 60px;
          background: #25D366;
          color: white;
          border: none;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          box-shadow: 0 4px 12px rgba(37, 211, 102, 0.4);
          transition: all 0.3s cubic-bezier(.645,.045,.355,1);
          z-index: 1000;
        }

        .whatsapp-float:hover {
          transform: scale(1.1);
          box-shadow: 0 6px 20px rgba(37, 211, 102, 0.5);
        }

        .whatsapp-float:active {
          transform: scale(0.95);
        }

        @media (max-width: 640px) {
          .whatsapp-float {
            width: 56px;
            height: 56px;
            bottom: 20px;
            right: 20px;
          }
        }
      `}</style>
    </>
  );
};

export default WhatsAppButton;
